import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=0ca5a244&scoped=true&"
import script from "./Connect.vue?vue&type=script&lang=js&"
export * from "./Connect.vue?vue&type=script&lang=js&"
import style0 from "./Connect.vue?vue&type=style&index=0&id=0ca5a244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5a244",
  null
  
)

export default component.exports